/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Control_Nav_PlannerInputs */

const en_control_nav_planner = /** @type {(inputs: Control_Nav_PlannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build Planner`)
};

const zh_control_nav_planner = /** @type {(inputs: Control_Nav_PlannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`配装规划`)
};

/**
* | output |
* | --- |
* | "Build Planner" |
*
* @param {Control_Nav_PlannerInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const control_nav_planner = /** @type {((inputs?: Control_Nav_PlannerInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Control_Nav_PlannerInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_control_nav_planner(inputs)
	return zh_control_nav_planner(inputs)
});
export { control_nav_planner as "control.nav.planner" }